var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/try-to-string.js
// module id = 76
// module chunks = 0 1